import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
const AlertDialog = ({ open, handleClose, onYes, title, description }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      sx={{ '& .MuiDialog-paper': { width: '50%', maxHeight: 435 } }}
      maxWidth="xs"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{t(title)}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(description)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>NO</Button>
        <Button onClick={onYes} autoFocus>
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};
AlertDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onYes: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string
};
export default React.memo(withBoundary(AlertDialog));
